import {apiClient} from "../../providers/apiClient";

const signIn = (username, password) => {
    const details = {
        grant_type: 'password',
        scope: 'openid offline_access',
        username: username,
        password: password,
        check_email_verification: false,
    };

    const body = Object.keys(details).map(key =>
        encodeURIComponent(key) + '=' + encodeURIComponent(details[key])
    ).join('&');

    
    
    return apiClient.post(
        '/admin/token',
        body,
        {
            headers: {
                ...apiClient.defaults.headers,
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            },
        }
    )
}

const signOut = () => {
    
}

const getMe = () => {
    
}

export default {
    signIn,
    signOut,
    getMe
}